import React from "react";
import classes from "./Loader.module.scss";

function Loader() {
  return <div className={classes.loader_container} />;
}

export default Loader;
